import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SystemModal from 'components/Shared/Modal';
import paymentsActions from 'redux/paymentsSpa/actions';
import AddCardForm from './AddCardForm';
import { ScaVerificationModal, ScaOrderChallengeModal } from 'pages/PaymentsSpa/modals';
import ScaOrderInitiatedIframe from 'pages/PaymentsSpa/PASFormView/ScaOrderIntiatedIframe';
import { useCreateSharedPayment } from 'services/reactQueryHooks/payments';
import useTranslation from 'utils/hooks/useTranslation';

import styles from './style.module.scss';

const AddCardModal = ({ visible, onClose }) => {
  const { translateText } = useTranslation();
  const dispatch = useDispatch();
  const { corporateClientId, currentCorporation } = useSelector(state => state.user);

  const [showVerification, setShowVerification] = useState(false);
  const [showChallenge, setShowChallenge] = useState(false);

  const {
    mutate: createPayment,
    isLoading,
    isError,
    isSuccess,
    scaChallenge,
    orderInitiated,
    reset,
  } = useCreateSharedPayment({
    onReset: () => {
      setShowChallenge(false);
      setShowVerification(false);
    },
  });

  const handleSubmit = payload => {
    createPayment({ card: payload, restrictionType: currentCorporation?.restrictionType });
  };

  const handleClose = useCallback(() => {
    reset();
    onClose();
  }, [reset, onClose]);

  useEffect(() => {
    if (scaChallenge) {
      setShowVerification(true);
    }
  }, [orderInitiated, scaChallenge]);

  useEffect(() => {
    if (isSuccess) {
      dispatch({ type: paymentsActions.GET });
      handleClose();
    }
  }, [isSuccess, dispatch, handleClose]);

  useEffect(() => {
    if (isError) {
      reset();
    }
  }, [isError, reset]);

  return (
    <SystemModal
      title={
        <div>
          <div className={styles.dashboardModalTitle}>
            {translateText('corporateAccounts.wallet.dashboard.addFunds.addNewCard')}
          </div>
          <div className={styles.dashboardModalSubtitle}>
            {translateText('corporateAccounts.wallet.dashboard.addFunds.addNewCardDescription')}
          </div>
        </div>
      }
      titleLevel={5}
      width={440}
      visible={visible}
      onCancel={handleClose}
      footer={null}
      bodyStyle={{ padding: '20px' }}
      className={styles.dashboardModal}
      destroyOnClose
      centered
      data-testid="addCardModal"
    >
      <ScaVerificationModal
        onOk={() => setShowChallenge(true)}
        onCancel={reset}
        visible={showVerification}
      />
      {showChallenge && (
        <ScaOrderChallengeModal
          visible={showChallenge}
          challengeHtml={scaChallenge}
          onCancel={reset}
        />
      )}
      {orderInitiated && <ScaOrderInitiatedIframe gatewayHtml={orderInitiated} />}
      <AddCardForm
        corporateClientId={corporateClientId}
        onCancel={handleClose}
        onSubmit={handleSubmit}
        submitting={isLoading}
        language={currentCorporation?.preferredLanguage}
      />
    </SystemModal>
  );
};

export default AddCardModal;
